var _defs, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _g4, _g5, _path11, _path12, _path13, _path14, _path15, _path16, _g6, _g7, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g8, _g9, _path24, _path25, _path26, _g10, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2065",
    "data-name": "Group 2065",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 156.594,
    height: 155.721,
    viewBox: "0 0 156.594 155.721",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1502",
    "data-name": "Rectangle 1502",
    width: 156.594,
    height: 155.721,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1479",
    "data-name": "Rectangle 1479",
    width: 56.027,
    height: 55.408,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1480",
    "data-name": "Rectangle 1480",
    width: 38.855,
    height: 118.11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48497",
    "data-name": "Path 48497",
    d: "M170.476,123.656l-16.1,4.1s-9.133-7.847-5.334-13.206-3.467-13.683-6.773-18.568c-8.969-13.253,8.095-20.567-1.939-38.526-2.669-4.777-9.5-12.974-7.24-19.078,2.575-6.953,8.606-4.618,9.792-9.926,1.855-8.3,8.872-14.6,17-11.324,8.018,3.236,8.6,17.739-.74,34.538-5.28,12.7-4.141,15.081-.251,20.285,2.725,3.645,12.527,11.724,9.006,18.847s-5.489,13.858-.772,17.115c7.178,4.956,3.355,15.745,3.355,15.745",
    transform: "translate(-132.638 -16.241)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1481",
    "data-name": "Rectangle 1481",
    width: 56.12,
    height: 98.924,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48504",
    "data-name": "Path 48504",
    d: "M174.7,128.753l-20.053,8.288c-2.313-2.184-5.916-6.489-2.241-9.436,5.109-4.1,1.023-13.787-2.07-16.52-3.828-3.382-12.568-11.436-4.77-17.886,6.491-5.369,11.793-7.6,8.351-16.856s-.668-17.1,8.286-20.241c9.422-3.306,11.908-17.953,21.108-17.288,16.031,1.16,12.9,26.067-.493,38.553S180.923,91.391,184.6,98.6c5.015,9.841-10.449,13.813-12.545,19.395-1.642,4.376.8,8.428,2.646,10.759",
    transform: "translate(-142.43 -38.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1482",
    "data-name": "Rectangle 1482",
    width: 82.247,
    height: 58.937,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1483",
    "data-name": "Rectangle 1483",
    width: 97.166,
    height: 88.495,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1485",
    "data-name": "Rectangle 1485",
    width: 44.949,
    height: 63.433,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48530",
    "data-name": "Path 48530",
    d: "M163.568,182.383l-44.949,3.673V122.731l44.949-.109Z",
    transform: "translate(-118.619 -122.622)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.836,
    y1: 1.11,
    x2: -1.82,
    y2: 1.11,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40447e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3c3b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3b6b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1497",
    "data-name": "Rectangle 1497",
    width: 38.828,
    height: 56.021,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48531",
    "data-name": "Path 48531",
    d: "M142.229,147.054l-18.936.595V128.867l18.936-.147Z",
    transform: "translate(-123.293 -128.72)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -4.53,
    y1: 3.496,
    x2: -4.493,
    y2: 3.496,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48532",
    "data-name": "Path 48532",
    d: "M170.99,131.214l-18.554.21V128.64l18.554-.144Z",
    transform: "translate(-152.436 -128.496)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5.716,
    y1: 22.652,
    x2: -5.678,
    y2: 22.652,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48533",
    "data-name": "Path 48533",
    d: "M170.99,138.47l-18.554.333v-2.784l18.554-.267Z",
    transform: "translate(-152.436 -135.752)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -5.716,
    y1: 20.084,
    x2: -5.678,
    y2: 20.084,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48534",
    "data-name": "Path 48534",
    d: "M170.99,146.005l-18.554.461v-2.784l18.554-.4Z",
    transform: "translate(-152.436 -143.287)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -5.716,
    y1: 17.626,
    x2: -5.678,
    y2: 17.626,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48535",
    "data-name": "Path 48535",
    d: "M170.99,152.983l-18.554.579v-2.785l18.554-.513Z",
    transform: "translate(-152.436 -150.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -5.716,
    y1: 15.522,
    x2: -5.678,
    y2: 15.522,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48536",
    "data-name": "Path 48536",
    d: "M162.2,162.751l-38.637,1.564v-2.857l38.637-1.425Z",
    transform: "translate(-123.568 -160.032)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.225,
    y1: 10.365,
    x2: -2.207,
    y2: 10.365,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48537",
    "data-name": "Path 48537",
    d: "M162.2,170.007l-38.637,1.823v-2.857l38.637-1.684Z",
    transform: "translate(-123.568 -167.289)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -2.225,
    y1: 8.664,
    x2: -2.207,
    y2: 8.664,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48538",
    "data-name": "Path 48538",
    d: "M162.2,177.263l-38.637,2.081v-2.857l38.637-1.942Z",
    transform: "translate(-123.568 -174.545)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.225,
    y1: 7.145,
    x2: -2.207,
    y2: 7.145,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48539",
    "data-name": "Path 48539",
    d: "M162.2,184.52l-38.637,2.34V184l38.637-2.2Z",
    transform: "translate(-123.568 -181.801)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2.225,
    y1: 5.781,
    x2: -2.207,
    y2: 5.781,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48540",
    "data-name": "Path 48540",
    d: "M162.2,196.241,123.568,199v-2.858l38.637-2.619Z",
    transform: "translate(-123.568 -193.523)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -2.225,
    y1: 3.851,
    x2: -2.207,
    y2: 3.851,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48541",
    "data-name": "Path 48541",
    d: "M162.2,203.5l-38.637,3.016v-2.858l38.637-2.877Z",
    transform: "translate(-123.568 -200.779)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -2.225,
    y1: 2.797,
    x2: -2.207,
    y2: 2.797,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1498",
    "data-name": "Rectangle 1498",
    width: 39.019,
    height: 55.855,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1499",
    "data-name": "Rectangle 1499",
    width: 50.236,
    height: 82.382,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1500",
    "data-name": "Rectangle 1500",
    width: 34.785,
    height: 35.418,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2064",
    "data-name": "Group 2064",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2063",
    "data-name": "Group 2063"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2062",
    "data-name": "Group 2062",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48486",
    "data-name": "Path 48486",
    d: "M154.291,66.514C150.047,38.732,132.644,4.6,98.264,1.028c0,0-26.1-3.174-51.834,1.638A58.007,58.007,0,0,0,9.294,26.241,51.13,51.13,0,0,0,1.425,67.564C3.656,76.79,5.164,86.338,4.75,95.818c-.522,11.956-1.5,24.527,3.781,35.677,7.744,16.335,26.64,21.147,43.127,22.682,6.076.566,12.174.793,18.255,1.274a110.287,110.287,0,0,0,35.991-3.608c57.3-15.478,52.631-57.548,48.387-85.33",
    transform: "translate(0 0)",
    fill: "#f4f7fa"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2006",
    "data-name": "Group 2006",
    transform: "translate(34.899 5.238)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2005",
    "data-name": "Group 2005"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2004",
    "data-name": "Group 2004",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48487",
    "data-name": "Path 48487",
    d: "M104.216,29.393l-2.983.2a23.293,23.293,0,0,0-1.35-3.843l2.475-1.661a1.468,1.468,0,0,0,.388-2.049l-2.887-4.247a1.5,1.5,0,0,0-2.063-.413l-2.508,1.674a23.953,23.953,0,0,0-3.094-2.673l1.322-2.716a1.492,1.492,0,0,0-.7-1.986L88.17,9.393a1.486,1.486,0,0,0-2,.665l-1.332,2.724a23.8,23.8,0,0,0-4.03-.8l-.232-3.055a1.526,1.526,0,0,0-1.613-1.4l-5.195.306a1.472,1.472,0,0,0-1.395,1.579l.232,3.064A23.637,23.637,0,0,0,68.7,13.767L66.95,11.212a1.545,1.545,0,0,0-2.112-.423L60.49,13.645a1.475,1.475,0,0,0-.4,2.078l1.759,2.555a23.444,23.444,0,0,0-2.728,3.074L56.3,19.993a1.534,1.534,0,0,0-2.045.68l-2.3,4.656a1.5,1.5,0,0,0,.716,2.014l2.792,1.34a23.035,23.035,0,0,0-.787,4.051l-3.092.209a1.507,1.507,0,0,0-1.419,1.606l.394,5.189a1.532,1.532,0,0,0,1.647,1.394l3.067-.216a23.251,23.251,0,0,0,1.376,3.924L54.13,46.524a1.486,1.486,0,0,0-.4,2.091l2.98,4.292a1.547,1.547,0,0,0,2.127.393l2.5-1.68a24.005,24.005,0,0,0,3.194,2.711l-1.308,2.676a1.487,1.487,0,0,0,.712,2l4.733,2.23a1.533,1.533,0,0,0,2.027-.708l1.29-2.651a23.892,23.892,0,0,0,4.127.752l.223,2.931a1.5,1.5,0,0,0,1.618,1.37l5.188-.409a1.5,1.5,0,0,0,1.385-1.6L84.3,58a23.562,23.562,0,0,0,3.931-1.369l1.656,2.407a1.5,1.5,0,0,0,2.077.383l4.254-2.9a1.481,1.481,0,0,0,.39-2.061L94.95,52.037a23.508,23.508,0,0,0,2.68-3.115l2.655,1.274a1.483,1.483,0,0,0,1.979-.692l2.216-4.6a1.481,1.481,0,0,0-.693-1.974l-2.66-1.285a22.937,22.937,0,0,0,.74-4.009l2.959-.209a1.468,1.468,0,0,0,1.362-1.576l-.386-5.085a1.492,1.492,0,0,0-1.586-1.373M77.324,20.254A15.27,15.27,0,0,1,93.56,34.233,15.017,15.017,0,0,1,79.6,50.294,15.263,15.263,0,0,1,63.2,36.326,15.011,15.011,0,0,1,77.324,20.254",
    transform: "translate(-50.165 -7.53)",
    fill: "#bfc8d6"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48488",
    "data-name": "Path 48488",
    d: "M165.3,107.91c4.127,2.849,4.433,7.7,4.1,11.249a5.116,5.116,0,0,0-.99.787c-3.406,2.909-5.479,3.424-9.288,5.761a23.377,23.377,0,0,1-4.863,1.476l-2.219.392s-8.623-7.671-4.825-13.03-3.467-13.683-6.773-18.568c-2.03-3-2-5.021-2.566-6.244-6.023-12.934-11.8-14.609-11.179-20.018.69-5.971,7.934-5.639,9.028-12.1,1.236-7.29-7.172-12.608-4.461-19.246a9.4,9.4,0,0,1,2.139-3.447c2.879-2.845,6.73-2.351,7.653-6.479,1.855-8.3,8.872-14.6,17-11.324,8.018,3.236,8.6,17.739-.74,34.538-5.28,12.7-4.141,15.081-.251,20.285,2.725,3.645,12.527,11.724,9.006,18.847s-5.489,13.858-.772,17.115",
    transform: "translate(-38.543 -4.942)",
    fill: "#4cbd01"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2011",
    "data-name": "Group 2011",
    transform: "translate(92.274 4.7)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2009",
    "data-name": "Group 2009",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2008",
    "data-name": "Group 2008",
    transform: "translate(0 6.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2007",
    "data-name": "Group 2007",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48489",
    "data-name": "Path 48489",
    d: "M170.76,121.887l-.307.118c-.669-1.691-1.322-3.4-1.939-5.094a177.165,177.165,0,0,1-9.338-37.18,144.677,144.677,0,0,1-.924-30.324,124.492,124.492,0,0,1,3.894-22.847,103.117,103.117,0,0,1,5.033-14.415c.341-.776.735-1.555,1.115-2.308.508-1,1.032-2.04,1.435-3.081l.307.093c-.408,1.056-.936,2.1-1.447,3.11-.379.749-.771,1.523-1.108,2.292a102.858,102.858,0,0,0-5.019,14.372,124.258,124.258,0,0,0-3.884,22.793A144.431,144.431,0,0,0,159.5,79.68a176.867,176.867,0,0,0,9.324,37.12c.616,1.687,1.268,3.4,1.936,5.087",
    transform: "translate(-140.308 -13.355)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48490",
    "data-name": "Path 48490",
    d: "M151.152,72.039l-.327.025c-.5-13.155-15.894-29.874-16.05-30.042l.251-.208c.156.168,15.62,16.965,16.126,30.225",
    transform: "translate(-133.288 -24.023)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48491",
    "data-name": "Path 48491",
    d: "M165.086,127.881l-.324.061c-1.457-8.855,10.51-22.554,10.631-22.692l.248.19c-.12.136-11.99,13.724-10.556,22.441",
    transform: "translate(-142.376 -43.328)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48492",
    "data-name": "Path 48492",
    d: "M159.481,136.906l-.31.113c-2.033-5.485-7.976-11.812-16.735-17.815-.44-.3-.44-.3-.461-.356l.308-.116-.154.058.122-.107c.026.024.193.138.385.269,8.809,6.038,14.791,12.414,16.845,17.954",
    transform: "translate(-135.479 -47.416)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48493",
    "data-name": "Path 48493",
    d: "M174.576,162.029l-.327.026c-.275-6.469,7.443-13.125,7.521-13.192l.214.223c-.077.066-7.676,6.622-7.408,12.942",
    transform: "translate(-145.299 -56.6)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48494",
    "data-name": "Path 48494",
    d: "M169.211,168.517c-3.579-3.858-8.5-6.824-15.049-9.07l.125-.289c6.6,2.263,11.561,5.257,15.176,9.152Z",
    transform: "translate(-139.188 -59.733)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48495",
    "data-name": "Path 48495",
    d: "M161.81,33.411l-.327.008a80.175,80.175,0,0,0-2.035-17.544c-.131-.611-.177-.826-.178-.9l.327-.021c0,.06.077.409.173.851a80.478,80.478,0,0,1,2.04,17.611",
    transform: "translate(-140.742 -15.848)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48496",
    "data-name": "Path 48496",
    d: "M159.717,52.725l-.311-.083c2.3-6.634,15.423-13.34,15.98-13.623l.145.27c-.136.068-13.558,6.926-15.814,13.436",
    transform: "translate(-140.784 -23.173)",
    fill: "#fcfdfe"
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48498",
    "data-name": "Path 48498",
    d: "M173.2,132.231c-.9.253-1.124,9.393-6,4.787-1.22-1.151-3.993-5.741-10.435-3.286l-3.75,1.43c-2.229-2.319-3.9-4.918-.609-7.557,5.109-4.1,1.023-13.787-2.07-16.52-3.828-3.382-12.568-11.436-4.77-17.886,6.491-5.369,11.793-7.6,8.351-16.855s-.668-17.1,8.285-20.241c9.422-3.307,11.909-17.953,21.108-17.288,16.031,1.16,12.9,26.067-.493,38.553S180.923,91.391,184.6,98.6a13.958,13.958,0,0,1,.968,3.16c1.524,8.5-6.013,13.26-9.123,22.062-4.242,12-1.718,7.983-3.238,8.409",
    transform: "translate(-43.344 -11.805)",
    fill: "#77f425"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2016",
    "data-name": "Group 2016",
    transform: "translate(98.398 26.311)",
    opacity: 0.3,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2015",
    "data-name": "Group 2015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2014",
    "data-name": "Group 2014",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2013",
    "data-name": "Group 2013",
    transform: "translate(0.688 0.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2012",
    "data-name": "Group 2012",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48499",
    "data-name": "Path 48499",
    d: "M172.369,129.395l-.461.1c-6.433-31.829,3.494-66.955,25.908-91.672l.351.286c-22.32,24.612-32.2,59.592-25.8,91.289",
    transform: "translate(-150.814 -38.497)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48500",
    "data-name": "Path 48500",
    d: "M161.748,136.741l-.434.182c-5.089-11.71-19.726-16.376-19.874-16.422l.158-.424c.15.047,14.98,4.77,20.15,16.665",
    transform: "translate(-142.128 -63.528)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48501",
    "data-name": "Path 48501",
    d: "M171.752,150.409l-.466-.034c1.459-12.957,23.774-24.037,24-24.146l.2.4c-.223.109-22.306,11.075-23.737,23.785",
    transform: "translate(-151.211 -65.401)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48502",
    "data-name": "Path 48502",
    d: "M171.62,88.893l-.469,0C171.385,78.59,159.6,67.8,159.486,67.7l.328-.328c.121.109,12.044,11.026,11.806,21.524",
    transform: "translate(-147.62 -47.489)",
    fill: "#fcfdfe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48503",
    "data-name": "Path 48503",
    d: "M188.06,64.465l-.378-.253c7.288-9.688,23.708-12.886,23.874-12.917l.077.438c-.163.03-16.4,3.195-23.573,12.732",
    transform: "translate(-156.201 -42.598)",
    fill: "#fcfdfe"
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48505",
    "data-name": "Path 48505",
    d: "M116.652,41.174a5.735,5.735,0,0,0-5.341-5.549l-.123,0L25.818,32.654l-.153-.006a6.219,6.219,0,0,0-6.555,5.978c0,.054-.022.109-.022.163v76.441a6.155,6.155,0,0,0,6.558,6.1l85.5-3.89a5.989,5.989,0,0,0,5.488-6.084V41.621c0-.151.024-.3.014-.447",
    transform: "translate(-5.809 -9.934)",
    fill: "#7f7f7f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48506",
    "data-name": "Path 48506",
    d: "M119.83,41.719v69.6a5.959,5.959,0,0,1-5.454,6.066L29.2,121.255a6.144,6.144,0,0,1-6.541-6.081V38.9c0-.054.028-.109.029-.163a6.2,6.2,0,0,1,6.527-5.964l85.165,2.959a5.843,5.843,0,0,1,5.446,5.542c.01.148,0,.3,0,.447",
    transform: "translate(-6.897 -9.972)",
    fill: "#e2e2e2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48507",
    "data-name": "Path 48507",
    d: "M119.83,41.722v4.329l-97.167-2.4V38.9c0-.054.028-.109.029-.163a6.336,6.336,0,0,1,6.681-5.959l85.143,2.959a5.713,5.713,0,0,1,5.315,5.537c.01.148,0,.3,0,.447",
    transform: "translate(-6.897 -9.974)",
    fill: "#424242"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48508",
    "data-name": "Path 48508",
    d: "M125.734,43.389a1.519,1.519,0,0,1-1.51,1.624L64.581,43.4a1.833,1.833,0,0,1-1.776-1.819V39.6a1.736,1.736,0,0,1,1.811-1.713l59.591,1.92a1.646,1.646,0,0,1,1.527,1.718Z",
    transform: "translate(-19.113 -11.53)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48509",
    "data-name": "Path 48509",
    d: "M37.867,40.111a1.929,1.929,0,0,1-2.016,1.918,2.072,2.072,0,0,1-2.024-2.038,1.93,1.93,0,0,1,2.024-1.919,2.073,2.073,0,0,1,2.016,2.038",
    transform: "translate(-10.294 -11.586)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48510",
    "data-name": "Path 48510",
    d: "M45.524,40.342a1.916,1.916,0,0,1-2,1.91,2.058,2.058,0,0,1-2-2.029,1.915,1.915,0,0,1,2-1.909,2.058,2.058,0,0,1,2,2.028",
    transform: "translate(-12.636 -11.659)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48511",
    "data-name": "Path 48511",
    d: "M53.107,40.572a1.9,1.9,0,0,1-1.978,1.9,2.043,2.043,0,0,1-1.985-2.018,1.9,1.9,0,0,1,1.985-1.9,2.043,2.043,0,0,1,1.978,2.018",
    transform: "translate(-14.955 -11.732)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2019",
    "data-name": "Group 2019",
    transform: "translate(23.991 42.3)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2018",
    "data-name": "Group 2018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2017",
    "data-name": "Group 2017",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48512",
    "data-name": "Path 48512",
    d: "M74.845,80.639l-40.359.038V60.8l40.359.692Z",
    transform: "translate(-34.486 -60.803)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48513",
    "data-name": "Path 48513",
    d: "M136.145,65.336l-37.872-.545v-2.9l37.872.649Z",
    transform: "translate(-53.897 -61.133)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48514",
    "data-name": "Path 48514",
    d: "M136.145,72.891l-37.872-.353v-2.9l37.872.456Z",
    transform: "translate(-53.897 -63.491)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48515",
    "data-name": "Path 48515",
    d: "M136.145,80.537l-37.872-.16v-2.7l37.872.257Z",
    transform: "translate(-53.897 -65.939)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48516",
    "data-name": "Path 48516",
    d: "M136.145,88l-37.872.033v-2.9l37.872.071Z",
    transform: "translate(-53.897 -68.207)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48517",
    "data-name": "Path 48517",
    d: "M117.068,98.089l-81.483.632V95.7l81.483-.408Z",
    transform: "translate(-34.821 -71.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48518",
    "data-name": "Path 48518",
    d: "M117.068,105.559l-81.483,1.047v-3.022l81.483-.824Z",
    transform: "translate(-34.821 -73.571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48519",
    "data-name": "Path 48519",
    d: "M117.068,113.03l-81.483,1.462V111.47l81.483-1.239Z",
    transform: "translate(-34.821 -75.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48520",
    "data-name": "Path 48520",
    d: "M117.068,120.5l-81.483,1.877v-3.022l81.483-1.654Z",
    transform: "translate(-34.821 -78.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48521",
    "data-name": "Path 48521",
    d: "M117.068,132.568l-81.483,2.548v-3.022l81.483-2.324Z",
    transform: "translate(-34.821 -81.791)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48522",
    "data-name": "Path 48522",
    d: "M117.068,140.039,35.585,143v-3.022l81.483-2.739Z",
    transform: "translate(-34.821 -84.064)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2022",
    "data-name": "Group 2022",
    transform: "translate(15.767 22.795)",
    opacity: 0.4,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2021",
    "data-name": "Group 2021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2020",
    "data-name": "Group 2020",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48523",
    "data-name": "Path 48523",
    d: "M119.83,108.052v3.264a5.959,5.959,0,0,1-5.454,6.066L29.2,121.254a6.144,6.144,0,0,1-6.541-6.081V38.9c0-.055.028-.109.029-.163a6.2,6.2,0,0,1,6.527-5.964l5.97.207a29.947,29.947,0,0,0,1.259,4.111,27.344,27.344,0,0,0,1.625,3.46,24.409,24.409,0,0,0,14.97,11.717q.812.24,1.615.493a56.83,56.83,0,0,1,16.653,7.955,36.493,36.493,0,0,1,3.835,3.227,33.233,33.233,0,0,1,2.639,2.874q.955,1.168,1.815,2.448a33.188,33.188,0,0,1,1.717,2.869,34.782,34.782,0,0,1,1.921,4.29q.511,1.377.932,2.854.338,1.178.614,2.424.308,1.381.538,2.85.2,1.25.336,2.565.149,1.387.229,2.851.068,1.186.088,2.424.025,1.393-.011,2.854-.013.566-.035,1.142a19.019,19.019,0,0,0,.34,4.7,11.014,11.014,0,0,0,.986,2.822,8.482,8.482,0,0,0,1.8,2.363A11.347,11.347,0,0,0,94.96,108.9c7.051,1.224,17.028-1.1,24.87-.853",
    transform: "translate(-22.663 -32.767)",
    fill: "#fff"
  }))))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48524",
    "data-name": "Path 48524",
    d: "M165.17,109.2v66.411a6.289,6.289,0,0,1-2.182,4.826,5.239,5.239,0,0,1-2.93,1.286L118.5,185.4a5.419,5.419,0,0,1-5.932-5.531V108.808c0-.051,0-.15,0-.2a5.929,5.929,0,0,1,5.945-5.82l41.544.624a5.486,5.486,0,0,1,5.163,5.313c.01.143-.054.333-.054.479",
    transform: "translate(-34.257 -31.279)",
    fill: "#47a00d"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48525",
    "data-name": "Path 48525",
    d: "M165.17,109.2v3.336l-52.6-.159v-3.57c0-.051,0-.15,0-.2a6.054,6.054,0,0,1,6.084-5.818l41.53.623a5.369,5.369,0,0,1,5.037,5.312c.01.143-.054.333-.054.479",
    transform: "translate(-34.257 -31.28)",
    fill: "#47a00d"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48526",
    "data-name": "Path 48526",
    d: "M171.469,109.824a1.539,1.539,0,0,1-1.492,1.6l-26.942-.168a1.642,1.642,0,0,1-1.6-1.686v-.464a1.613,1.613,0,0,1,1.6-1.659l26.947.3a1.565,1.565,0,0,1,1.483,1.628Z",
    transform: "translate(-43.042 -32.699)",
    fill: "#47a00d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48527",
    "data-name": "Path 48527",
    d: "M120.876,109.27a1.846,1.846,0,0,1-1.847,1.862,1.884,1.884,0,0,1-1.855-1.894,1.845,1.845,0,0,1,1.855-1.862,1.885,1.885,0,0,1,1.847,1.894",
    transform: "translate(-35.658 -32.676)",
    fill: "#47a00d"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48528",
    "data-name": "Path 48528",
    d: "M127.882,109.335a1.829,1.829,0,0,1-1.824,1.851,1.867,1.867,0,0,1-1.833-1.882,1.828,1.828,0,0,1,1.833-1.851,1.867,1.867,0,0,1,1.824,1.882",
    transform: "translate(-37.804 -32.7)",
    fill: "#47a00d"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48529",
    "data-name": "Path 48529",
    d: "M134.8,109.4a1.812,1.812,0,0,1-1.8,1.839,1.85,1.85,0,0,1-1.81-1.871A1.811,1.811,0,0,1,133,107.53a1.85,1.85,0,0,1,1.8,1.87",
    transform: "translate(-39.923 -32.723)",
    fill: "#47a00d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2027",
    "data-name": "Group 2027",
    transform: "translate(82.521 85.306)",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2026",
    "data-name": "Group 2026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2024",
    "data-name": "Group 2024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2023",
    "data-name": "Group 2023",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1484",
    "data-name": "Rectangle 1484",
    width: 44.949,
    height: 63.433,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(85.773 89.392)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2051",
    "data-name": "Group 2051"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2050",
    "data-name": "Group 2050",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2029",
    "data-name": "Group 2029",
    transform: "translate(0 0.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2028",
    "data-name": "Group 2028",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1486",
    "data-name": "Rectangle 1486",
    width: 18.936,
    height: 18.929,
    transform: "translate(0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(20.274 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1487",
    "data-name": "Rectangle 1487",
    width: 18.554,
    height: 2.928,
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2033",
    "data-name": "Group 2033",
    transform: "translate(20.274 5.048)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2032",
    "data-name": "Group 2032",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1488",
    "data-name": "Rectangle 1488",
    width: 18.554,
    height: 3.051,
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(20.274 10.29)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2034",
    "data-name": "Group 2034",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    width: 18.554,
    height: 3.179,
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2037",
    "data-name": "Group 2037",
    transform: "translate(20.274 15.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1490",
    "data-name": "Rectangle 1490",
    width: 18.554,
    height: 3.298,
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2039",
    "data-name": "Group 2039",
    transform: "translate(0.191 21.939)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2038",
    "data-name": "Group 2038",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1491",
    "data-name": "Rectangle 1491",
    width: 38.637,
    height: 4.283,
    transform: "translate(0)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2041",
    "data-name": "Group 2041",
    transform: "translate(0.191 26.988)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2040",
    "data-name": "Group 2040",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1492",
    "data-name": "Rectangle 1492",
    width: 38.637,
    height: 4.541,
    transform: "translate(0)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2043",
    "data-name": "Group 2043",
    transform: "translate(0.191 32.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2042",
    "data-name": "Group 2042",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1493",
    "data-name": "Rectangle 1493",
    width: 38.637,
    height: 4.8,
    transform: "translate(0)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2045",
    "data-name": "Group 2045",
    transform: "translate(0.191 37.084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2044",
    "data-name": "Group 2044",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1494",
    "data-name": "Rectangle 1494",
    width: 38.637,
    height: 5.059,
    transform: "translate(0)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2047",
    "data-name": "Group 2047",
    transform: "translate(0.191 45.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2046",
    "data-name": "Group 2046",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 38.637,
    height: 5.476,
    transform: "translate(0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2049",
    "data-name": "Group 2049",
    transform: "translate(0.191 50.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2048",
    "data-name": "Group 2048",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1496",
    "data-name": "Rectangle 1496",
    width: 38.637,
    height: 5.735,
    transform: "translate(0)",
    fill: "url(#linear-gradient-12)"
  }))))))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48542",
    "data-name": "Path 48542",
    d: "M168.553,109.233v66.2a6.318,6.318,0,0,1-2.2,4.817,5.368,5.368,0,0,1-2.969,1.288L122.009,185.2a5.377,5.377,0,0,1-5.865-5.524V108.843c0-.051.032-.15.033-.2a5.893,5.893,0,0,1,5.9-5.8l41.31.62a5.5,5.5,0,0,1,5.177,5.3c.01.143-.01.332-.01.477",
    transform: "translate(-35.345 -31.296)",
    fill: "#ebf4e6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48543",
    "data-name": "Path 48543",
    d: "M168.553,109.234v3.325l-52.409-.157v-3.558c0-.051.032-.15.033-.2a6.016,6.016,0,0,1,6.037-5.8l41.3.619a5.384,5.384,0,0,1,5.052,5.295c.01.143-.01.332-.01.477",
    transform: "translate(-35.345 -31.297)",
    fill: "#4cbd01"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48544",
    "data-name": "Path 48544",
    d: "M174.577,109.853a1.516,1.516,0,0,1-1.461,1.6l-26.79-.17a1.638,1.638,0,0,1-1.588-1.683v-.463a1.616,1.616,0,0,1,1.606-1.652l26.774.3a1.547,1.547,0,0,1,1.459,1.624Z",
    transform: "translate(-44.046 -32.709)",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48545",
    "data-name": "Path 48545",
    d: "M124.49,109.3a1.838,1.838,0,0,1-1.835,1.856,1.875,1.875,0,0,1-1.844-1.888,1.836,1.836,0,0,1,1.844-1.855,1.876,1.876,0,0,1,1.835,1.887",
    transform: "translate(-36.765 -32.689)",
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48546",
    "data-name": "Path 48546",
    d: "M131.452,109.369a1.82,1.82,0,0,1-1.813,1.844,1.858,1.858,0,0,1-1.822-1.876,1.82,1.82,0,0,1,1.822-1.844,1.859,1.859,0,0,1,1.813,1.876",
    transform: "translate(-38.897 -32.712)",
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48547",
    "data-name": "Path 48547",
    d: "M138.329,109.432a1.8,1.8,0,0,1-1.791,1.834,1.842,1.842,0,0,1-1.8-1.865,1.8,1.8,0,0,1,1.8-1.833,1.843,1.843,0,0,1,1.791,1.864",
    transform: "translate(-41.003 -32.735)",
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48548",
    "data-name": "Path 48548",
    d: "M166.867,182.183l-44.949,3.671V122.722l44.949-.111Z",
    transform: "translate(-37.102 -37.313)",
    fill: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2055",
    "data-name": "Group 2055",
    transform: "translate(87.877 89.371)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2054",
    "data-name": "Group 2054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48549",
    "data-name": "Path 48549",
    d: "M145.062,146.98l-18.744.595V128.846l18.744-.15Z",
    transform: "translate(-126.317 -128.536)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48550",
    "data-name": "Path 48550",
    d: "M174.456,131.175l-18.171.212v-2.775l18.171-.147Z",
    transform: "translate(-135.437 -128.466)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48551",
    "data-name": "Path 48551",
    d: "M174.456,138.409l-18.171.335v-2.776l18.171-.269Z",
    transform: "translate(-135.437 -130.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48552",
    "data-name": "Path 48552",
    d: "M174.456,145.92l-18.171.461v-2.776l18.171-.4Z",
    transform: "translate(-135.437 -132.953)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48553",
    "data-name": "Path 48553",
    d: "M174.456,152.875l-18.171.578v-2.775l18.171-.513Z",
    transform: "translate(-135.437 -135.069)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48554",
    "data-name": "Path 48554",
    d: "M165.5,162.612l-38.637,1.568v-2.849L165.5,159.9Z",
    transform: "translate(-126.484 -138.033)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48555",
    "data-name": "Path 48555",
    d: "M165.5,169.846l-38.637,1.826v-2.848l38.637-1.688Z",
    transform: "translate(-126.484 -140.234)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48556",
    "data-name": "Path 48556",
    d: "M165.5,177.079l-38.637,2.084v-2.848l38.637-1.946Z",
    transform: "translate(-126.484 -142.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48557",
    "data-name": "Path 48557",
    d: "M165.5,184.312l-38.637,2.342v-2.848l38.637-2.2Z",
    transform: "translate(-126.484 -144.636)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48558",
    "data-name": "Path 48558",
    d: "M165.5,196l-38.637,2.76v-2.849l38.637-2.621Z",
    transform: "translate(-126.484 -148.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48559",
    "data-name": "Path 48559",
    d: "M165.5,203.23l-38.637,3.018V203.4l38.637-2.879Z",
    transform: "translate(-126.484 -150.393)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2058",
    "data-name": "Group 2058",
    transform: "translate(80.799 71.543)",
    opacity: 0.4,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2057",
    "data-name": "Group 2057"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2056",
    "data-name": "Group 2056",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48560",
    "data-name": "Path 48560",
    d: "M166.38,180.253a5.418,5.418,0,0,1-2.984,1.288l-41.38,3.659a5.382,5.382,0,0,1-5.872-5.524V108.844c0-.051.032-.15.033-.2a5.893,5.893,0,0,1,5.9-5.8l6.269.094c-.249,1.21-.521,2.434-.76,3.928-.124.776-.234,1.623-.329,2.479-.11.991-.191,2.038-.234,3.1a35.323,35.323,0,0,0,.072,4.232,24.81,24.81,0,0,0,.72,4.364c1.014,3.834,3.1,7.209,6.942,9.068,2.708,1.308,5.2,2.5,7.419,3.784a32.283,32.283,0,0,1,3.654,2.412,20.083,20.083,0,0,1,2.862,2.66,17.27,17.27,0,0,1,2.638,4.013,19.832,19.832,0,0,1,1.039,2.689c.224.723.418,1.485.583,2.293q.262,1.274.425,2.706.135,1.163.2,2.441c.044.865.064,1.771.059,2.72q0,1.117-.054,2.317-.056,1.314-.167,2.733-.07.87-.159,1.783c-.141,1.409-.209,2.68-.212,3.826a24.6,24.6,0,0,0,.125,2.716,15.428,15.428,0,0,0,.4,2.286,9.145,9.145,0,0,0,1.1,2.637,6.9,6.9,0,0,0,3.066,2.614c2.861,1.31,6.376,1.22,8.64,3.522",
    transform: "translate(-116.144 -102.839)",
    fill: "#fff"
  }))))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48561",
    "data-name": "Path 48561",
    d: "M68.479,186.255A17.859,17.859,0,0,1,50,204.467c-10.787-.331-19.86-9.648-19.86-20.8A17.808,17.808,0,0,1,50,165.551a21.048,21.048,0,0,1,18.476,20.7",
    transform: "translate(-9.173 -50.348)",
    fill: "#367f06"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48562",
    "data-name": "Path 48562",
    d: "M72.5,184.97a17.859,17.859,0,0,1-18.476,18.212c-10.787-.331-19.86-9.648-19.86-20.8a17.808,17.808,0,0,1,19.86-18.119A21.048,21.048,0,0,1,72.5,184.97",
    transform: "translate(-10.398 -49.957)",
    fill: "#47a00d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48563",
    "data-name": "Path 48563",
    d: "M72.1,185.306a17.043,17.043,0,0,1-17.662,17.381A19.96,19.96,0,0,1,35.516,182.84a17,17,0,0,1,18.923-17.3A20.084,20.084,0,0,1,72.1,185.306",
    transform: "translate(-10.808 -50.349)",
    fill: "#4cbd01"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2061",
    "data-name": "Group 2061",
    transform: "translate(25.651 116.018)",
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2060",
    "data-name": "Group 2060"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2059",
    "data-name": "Group 2059",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48564",
    "data-name": "Path 48564",
    d: "M71.657,185.65A16.218,16.218,0,0,1,57,202.113a16.988,16.988,0,0,1-2.154.064,18.981,18.981,0,0,1-17.972-18.871,16.153,16.153,0,0,1,14.243-16.421,17.015,17.015,0,0,1,3.729-.027A19.1,19.1,0,0,1,71.657,185.65",
    transform: "translate(-36.872 -166.768)",
    fill: "#fff"
  }))))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48565",
    "data-name": "Path 48565",
    d: "M57,202.164a16.978,16.978,0,0,1-2.153.064,18.981,18.981,0,0,1-17.972-18.871,16.153,16.153,0,0,1,14.243-16.422c2.717,2.122,5.149,4.836,5.568,8.053.684,5.243-4.554,7.656-5.132,13.354-.475,4.7,1.776,9.939,5.446,13.822",
    transform: "translate(-11.22 -50.801)",
    fill: "#9af261"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48566",
    "data-name": "Path 48566",
    d: "M55.579,199.32a2.244,2.244,0,0,1-1.928-1.1l-6.834-11.522a2.294,2.294,0,0,1,.77-3.125,2.233,2.233,0,0,1,3.085.779l4.745,8,6.272-12.476a2.235,2.235,0,0,1,3.025-1,2.291,2.291,0,0,1,.984,3.062l-8.114,16.14a2.247,2.247,0,0,1-1.925,1.243h-.079",
    transform: "translate(-14.149 -54.359)",
    fill: "#fff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48567",
    "data-name": "Path 48567",
    d: "M59.721,160.641a.772.772,0,0,1-.765-.806v-1.21a.766.766,0,1,1,1.531,0v1.21a.772.772,0,0,1-.765.806",
    transform: "translate(-17.941 -48.027)",
    fill: "#424242"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48568",
    "data-name": "Path 48568",
    d: "M59.721,147.791a.772.772,0,0,1-.765-.806v-2.218a.766.766,0,1,1,1.531,0v2.218a.772.772,0,0,1-.765.806m0-5.04a.773.773,0,0,1-.765-.807v-2.217a.766.766,0,1,1,1.531,0v2.217a.773.773,0,0,1-.765.807m0-5.04a.772.772,0,0,1-.765-.806v-2.217a.766.766,0,1,1,1.531,0V136.9a.772.772,0,0,1-.765.806m0-5.04a.772.772,0,0,1-.765-.806v-2.218a.766.766,0,1,1,1.531,0v2.218a.772.772,0,0,1-.765.806",
    transform: "translate(-17.941 -39.209)",
    fill: "#424242"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48569",
    "data-name": "Path 48569",
    d: "M59.721,125a.772.772,0,0,1-.765-.806v-1.21a.766.766,0,1,1,1.531,0v1.21a.772.772,0,0,1-.765.806",
    transform: "translate(-17.941 -37.181)",
    fill: "#424242"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48570",
    "data-name": "Path 48570",
    d: "M91.239,191.692a.807.807,0,0,1-.074-1.61l2.409-.223a.807.807,0,1,1,.148,1.606l-2.408.223c-.025,0-.05,0-.075,0m5.419-.5a.806.806,0,0,1-.073-1.609l2.408-.223a.807.807,0,0,1,.149,1.606l-2.409.223c-.025,0-.05,0-.075,0m5.42-.5a.806.806,0,0,1-.073-1.609l2.408-.223a.806.806,0,1,1,.148,1.606l-2.408.223c-.025,0-.051,0-.075,0m5.42-.5a.806.806,0,0,1-.074-1.609l2.409-.223a.807.807,0,1,1,.148,1.606l-2.408.223c-.026,0-.051,0-.075,0m5.419-.5a.806.806,0,0,1-.073-1.609l2.408-.223a.806.806,0,0,1,.149,1.606l-2.409.223c-.025,0-.05,0-.075,0",
    transform: "translate(-27.52 -57.167)",
    fill: "#424242"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48571",
    "data-name": "Path 48571",
    d: "M178.521,86.971a.772.772,0,0,1-.765-.806v-.4a.766.766,0,1,1,1.53,0v.4a.772.772,0,0,1-.765.806m0-3.427a.772.772,0,0,1-.765-.806V80.319a.766.766,0,1,1,1.53,0v2.419a.772.772,0,0,1-.765.806m0-5.443a.772.772,0,0,1-.765-.806V74.876a.766.766,0,1,1,1.53,0v2.419a.772.772,0,0,1-.765.806m0-5.443a.772.772,0,0,1-.765-.806V69.433a.766.766,0,1,1,1.53,0v2.419a.772.772,0,0,1-.765.806M178.5,67.2a.554.554,0,0,1-.511-.221h-1.684a.766.766,0,1,1,0-1.531h2.218a.733.733,0,0,1,.762.762v.2a.771.771,0,0,1-.784.787m-5.219-.221h-2.419a.766.766,0,1,1,0-1.531h2.419a.766.766,0,1,1,0,1.531m-5.443,0h-2.419a.766.766,0,1,1,0-1.531h2.419a.766.766,0,1,1,0,1.531",
    transform: "translate(-50.095 -19.916)",
    fill: "#424242"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48572",
    "data-name": "Path 48572",
    d: "M62.444,121.5a3.174,3.174,0,1,1-3.174-3.174,3.174,3.174,0,0,1,3.174,3.174",
    transform: "translate(-17.071 -36.007)",
    fill: "#424242"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48573",
    "data-name": "Path 48573",
    d: "M127.932,187.564a3.174,3.174,0,1,1-3.174-3.174,3.174,3.174,0,0,1,3.174,3.174",
    transform: "translate(-37 -56.113)",
    fill: "#424242"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48574",
    "data-name": "Path 48574",
    d: "M160.1,65.57a3.174,3.174,0,1,1-3.174-3.174A3.174,3.174,0,0,1,160.1,65.57",
    transform: "translate(-46.788 -18.988)",
    fill: "#424242"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_48575",
    "data-name": "Path 48575",
    d: "M186.466,96a3.174,3.174,0,1,1-3.174-3.174A3.174,3.174,0,0,1,186.466,96",
    transform: "translate(-54.813 -28.247)",
    fill: "#424242"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncPolicy);
export default __webpack_public_path__ + "static/media/SyncPolicy.b58c3d61446426bfaa73de77cd5f2e6d.svg";
export { ForwardRef as ReactComponent };